<div class="div-container-date kf-date-time kf-editable-field">
    <div class="d-flex
         {{'kf-field-xs-' + labelCols}}
         {{'kf-field-sm-' + labelColsSm}}
         {{'kf-field-md-' + labelColsMd}}
         {{'kf-field-lg-' + labelColsLg}}
         {{'kf-field-xl-' + labelColsXl}}
         {{'kf-field-xxl-' + labelColsXxl}}">
        <!-- Label -->
        <div class="kf-input-label">
            @if(isEditable$ | async) {
                <label for="{{id}}">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </label>
            }
            @else {
                <div class="kf-label">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </div>
            }
        </div>
        <div class="kf-input col">
            <div class="d-inline-flex flex-wrap" [class.month-year-picker]="!!dayOverride">
                @if(allowDate) {
                    @if(!(isEditable$ | async)) {
                        <span class="mt-1">{{!!_displayDateValue ? _displayDateValue : isBlankReadOnlyText}}</span>
                    }
                    @else{
                        <!--  This is the input users can type into  -->
                        <input class="input-date-string"
                               type="text"
                               [name]="prop"
                               [id]="id"
                               [(ngModel)]="_displayDateValue"
                               (blur)="onStringChange()"
                               [placeholder]="placeholder" />
                        
                        <!--  This is the hidden input that creates the date picker -->
                        <label class="sr-only" for="{{id}}_picker">{{label}}</label>
                        <input class="input-date" [class.d-none]="!(isEditable$ | async)"
                               type="text"
                               [placeholder]="placeholder"
                               [name]="prop"
                               id="{{id}}_picker"
                               [(ngModel)]="dateModel"
                               (ngModelChange)="dateModel=$event; onChange()"
                               [minDate]="minDateModel"
                               [maxDate]="maxDateModel"
                               [firstDayOfWeek]="7"
                               autoClose="true"
                               #c2="ngModel"
                               [contentTemplate]="!!dayOverride ? monthYearTemplate : null"
                               [footerTemplate]="footer"
                               ngbDatepicker
                               #datePicker="ngbDatepicker" />
                        <!-- Select date button -->
                        <button #openPicker
                                class="kf-btn-xs kf-btn kf-btn-blue"
                                [class.mb-1]="labelCols != 12"
                                type="button"
                                (click)="openFocusedPicker()">
                            <i class="far fa-calendar-alt"></i><span class="sr-only">Click to display calendar</span>
                        </button>
                        <!-- Clear date button -->
                        @if (!!allowEmpty) {
                            <button class="kf-btn-xs kf-btn kf-btn-blue ms-1"
                                    [class.mb-1]="labelCols != 12"
                                    type="button"
                                    (click)="clear();"
                                    title="Clear date">
                                <i class="fas fa-trash-alt">
                                    <span class="sr-only">Click to clear date</span>
                                </i>
                            </button>
                        }
                    }
                }
                
                <!--  Optional Time Picker  -->
                @if (allowTime) {
                    @if(!(isEditable$ | async)) {
                        <span class="mt-1" [class.ms-1]="allowDate && !!_displayDateValue">{{_displayTimeValue}}</span>
                    }
                    @else{
                        <div [class.ms-2]="!!allowDate">
                            <ngb-timepicker [(ngModel)]="timeModel" class="kf-timepicker kf-btn-blue"
                                            (ngModelChange)="onChangeTime($event)"
                                            [meridian]="true"
                                            [spinners]="false"
                                            size="small"></ngb-timepicker>
                        </div>
                    }
                }
                
                <!--  TEMPLATES  -->
                <ng-template #monthYearTemplate>
                    <div class="my-template">
                        <div class="nav">
                            <div class="ngb-dp-arrow ngb-dp-arrow-prev">
                                <button type="button" aria-label="Previous year" title="Previous year"
                                        (click)="selectedYear = selectedYear-1"
                                        [disabled]="!selectedYear || (yearsMonthDetails.lowerBound.year == selectedYear)">
                                    <span class="ngb-dp-navigation-chevron"></span>
                                </button>
                            </div>
                            @if(!!yearsMonthDetails?.availableDates){
                                <ngb-datepicker-navigation-select class="ngb-dp-navigation-select">
                                    <select aria-label="Select year" title="Select year" class="form-select mx-4"
                                            [(ngModel)]="selectedYear"
                                            (change)="onMonthYearSelect()">
                                        <option ngValue="" hidden disabled></option>
                                        <option ngValue="1900" hidden disabled></option>
                                        @for (year of yearsMonthDetails.availableDates | keyvalue; track year.key) {
                                            <option [ngValue]="+year.key">{{year.key}}</option>
                                        }
                                    </select>
                                </ngb-datepicker-navigation-select>
                                <div class="ngb-dp-arrow ngb-dp-arrow-next">
                                    <button type="button" aria-label="Next year" title="Next year"
                                            (click)="selectedYear = selectedYear+1"
                                            [disabled]="!selectedYear || (yearsMonthDetails.upperBound.year == selectedYear)">
                                        <span class="ngb-dp-navigation-chevron"></span>
                                    </button>
                                </div>
                            }
                        </div>
                        <div class="container">
                            <div class="row row-cols-3">
                                @for(month of monthNames; track month; let index = $index){
                                    <div class="col text-center month-picker-button user-select-none py-1"
                                         [class.month-enabled]="yearsMonthDetails.availableDates[selectedYear]?.includes(month)"
                                         [class.month-disabled]="!yearsMonthDetails.availableDates[selectedYear]?.includes(month)"
                                         [class.month-selected]="(index+1 == selectedMonth) && yearsMonthDetails.availableDates[selectedYear]?.includes(month) && (dateModel.month == selectedMonth) && (dateModel.year == selectedYear)"
                                         tabindex="0"
                                         (click)="selectedMonth = index+1; onMonthYearSelect()"
                                         (keyup.enter)="selectedMonth = index+1; onMonthYearSelect()">
                                        {{month}}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </ng-template>
                
                <ng-template #footer>
                    <div class="d-flex justify-content-between p-2">
                        <button class="kf-btn kf-btn-light-gray kf-btn-xs" type="button" (click)="datePicker.close()" #focusButton>Close</button>
                        <button class="kf-btn kf-btn-blue kf-btn-xs" type="button" (click)="setToday()">Today</button>
                    </div>
                </ng-template>
            </div>
            
        </div>
    </div>
    
    <!--  Errors/Warnings  -->
    @if (isEditable$ | async) {
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
    @else{
        @if(allowReadOnlyWarnings){
            <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true" [supressErrors]="true"></observable-errors-warnings>
        }
    }
</div>

